/*
 * @Description: 文件预览
 * @Date: 2021-11-01 14:26:22
 */

const fileTypeReg = new RegExp(
  /\.pdf|\.doc|\.dot|\.docx|\.dotx|\.xlc|\.xlm|\.xls|\.xlt|\.xlw|\.xlsx|\.xltx|\.xlsm|\.xlsb|\.ppt|\.pptx/,
  'i'
);
const imageTypeReg = new RegExp(/\.bmp|\.jpg|\.png|\.gif|\.jpeg/, 'i');
const zipTypeReg = new RegExp(
  /\.rar|\.cab|\.arj|\.lzh|\.ace|\.7-zip|\.tar|\.gzip|\.uue|\.bz2|\.jar|\.iso|\.z/,
  'i'
);
const isObject = data => {
  return Object.prototype.toString.call(data) === '[object Object]';
};
const isArray = data => {
  return Object.prototype.toString.call(data) === '[object Array]';
};
export const getFileType = url => {
  if (typeof url === 'string') {
    if (imageTypeReg.test(url)) {
      return 'image';
    }
    if (fileTypeReg.test(url)) {
      return 'file';
    }
    if (zipTypeReg.test(url)) {
      return 'zip';
    }
  }

  return '';
};

/**
 * @description: 通过URL后缀整理出文件集合，不处理ZIP。修改了push连接类型，只添加图片，文件不再push了
 * @param {array} list 接口初始数据
 * @return {array} [{url,type}]
 */
export default function(list) {
  const arr = [];
  Array.isArray(list) &&
    list.forEach(item => {
      let values = item.values;
      try {
        values = JSON.parse(values);
      } catch (e) {
        console.error(e);
      }
      let fileType = getFileType(values);
      if (values && fileType === 'image') {
        arr.push({
          type: fileType,
          url: values
        });
      }
      if (isObject(values)) {
        const objValue = values.addressPicUrl || values.url;
        fileType = getFileType(objValue);
        if (objValue && fileType === 'image') {
          arr.push({
            type: fileType,
            url: objValue
          });
        }
      }
      if (isArray(values)) {
        values.forEach(item2 => {
          if (isObject(item2)) {
            const curValue = item2.url || item2.imgUrl;
            fileType = getFileType(curValue);
            if (curValue && fileType == 'image') {
              arr.push({
                type: fileType,
                url: curValue
              });
            }
          } else {
            const curValue = item2;
            fileType = getFileType(curValue);
            if (curValue && fileType == 'image') {
              arr.push({
                type: fileType,
                url: curValue
              });
            }
          }
        });
      }
    });
  return arr;
}
